import type { ReactElement } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuthStore } from '@/entities/user';
import { Button, CenteredLayout } from '@/shared/ui';

/**
 * 관리자 앱 보호 라우트 가드.
 *
 * 비로그인은 로그인 화면으로(원래 목적지를 쿼리까지 state.from 으로 넘겨 로그인 뒤 돌아온다 — 알림 메일의 상세 링크),
 * ADMIN 이 아닌 계정은 접근 불가 안내로 보낸다 —
 * 서버(adminProcedure · @Roles)가 실제 방어선이고 이 가드는 UX 용이다.
 */
export const RequireAdmin = (): ReactElement => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const user = useAuthStore((state) => state.user);
  const clear = useAuthStore((state) => state.clear);
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate to="/sign-in" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }

  if (user?.role !== 'ADMIN') {
    return (
      <CenteredLayout title="접근 권한 없음" description="관리자 계정으로만 이용할 수 있습니다.">
        <Button type="button" variant="outline" onClick={() => clear()}>
          다른 계정으로 로그인
        </Button>
      </CenteredLayout>
    );
  }

  return <Outlet />;
};
